export const evPerChargingPoint = {
  'nl': {
    'public': {
      2020: {
        inhabitants: 2.5,
        commuters: 2.0,
        visitors: 10,
      },
      2021: {
        inhabitants: 2.8,
        commuters: 2.4,
        visitors: 12,
      },
      2022: {
        inhabitants: 3.1,
        commuters: 2.8,
        visitors: 14,
      },
      2023: {
        inhabitants: 3.4,
        commuters: 3.2,
        visitors: 16,
      },
      2024: {
        inhabitants: 3.7,
        commuters: 3.6,
        visitors: 18,
      },
      2025: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2026: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2027: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2028: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2029: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2030: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2031: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2032: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2033: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2034: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2035: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2036: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2037: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2038: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2039: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2040: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2041: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2042: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2043: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2044: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2045: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2046: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2047: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2048: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2049: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
      2050: {
        inhabitants: 4.0,
        commuters: 4.0,
        visitors: 20,
      },
    },
    'private': {
      2020: {
        inhabitants: 1,
        commuters: 2.0,
        visitors: 5,
      },
      2021: {
        inhabitants: 1,
        commuters: 2.4,
        visitors: 6,
      },
      2022: {
        inhabitants: 1,
        commuters: 2.8,
        visitors: 7,
      },
      2023: {
        inhabitants: 1,
        commuters: 3.2,
        visitors: 8,
      },
      2024: {
        inhabitants: 1,
        commuters: 3.6,
        visitors: 9,
      },
      2025: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2026: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2027: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2028: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2029: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2030: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2031: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2032: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2033: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2034: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2035: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2036: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2037: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2038: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2039: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2040: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2041: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2042: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2043: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2044: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2045: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2046: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2047: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2048: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2049: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2050: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
    },
  },
  'be': {
    'public': {
      2020: {
        inhabitants: 2.5,
        commuters: 2.0,
        visitors: 10,
      },
      2021: {
        inhabitants: 2.8,
        commuters: 3.22,
        visitors: 12,
      },
      2022: {
        inhabitants: 3.1,
        commuters: 3.565,
        visitors: 14,
      },
      2023: {
        inhabitants: 3.4,
        commuters: 3.91,
        visitors: 16,
      },
      2024: {
        inhabitants: 3.7,
        commuters: 4.255,
        visitors: 18,
      },
      2025: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
      2026: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
      2027: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
      2028: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
      2029: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
      2030: {
        inhabitants: 4.0,
        commuters: 4.6,
        visitors: 20,
      },
    },
    'private': {
      2020: {
        inhabitants: 1,
        commuters: 2.0,
        visitors: 5,
      },
      2021: {
        inhabitants: 1,
        commuters: 2.4,
        visitors: 6,
      },
      2022: {
        inhabitants: 1,
        commuters: 2.8,
        visitors: 7,
      },
      2023: {
        inhabitants: 1,
        commuters: 3.2,
        visitors: 8,
      },
      2024: {
        inhabitants: 1,
        commuters: 3.6,
        visitors: 9,
      },
      2025: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2026: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2027: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2028: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2029: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
      2030: {
        inhabitants: 1,
        commuters: 4.0,
        visitors: 10,
      },
    },
  },
  'uk': {
  },
  'de': {
  },
}
